import { CharsetKey } from "lib/models";

// Characters to use in pw
const charsets: Record<CharsetKey, string> = {
  uc: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  lc: "abcdefghijklmnopqrstuvwxyz",
  n: "0123456789",
  s: "@%+!#$^?:.(){}[]~-_",
};

export const charsetWithLabels: Record<CharsetKey, string> = {
  uc: "Uppercase",
  lc: "Lowercase",
  n: "Numbers",
  s: "Symbols",
};

/**
 * Generate a random-ish password
 * @param sets Which characters to include
 * @param length How long should it be
 * @returns string password
 */
export const generatePassword = (
  sets: CharsetKey[],
  length: number
): string => {
  const chars = sets.map((key) => charsets[key]).join();
  let pw = "";
  for (let i = 0; i < length; i++) {
    pw += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return pw;
};
